import { Box, Grid, Skeleton, Stack, theme } from '@lojinha/design-system'
import React, { FC } from 'react'

export const LoadingSummary: FC = () => {
  return (
    <Box
      marginTop={['x56', 'x56', 'x96']}
      marginBottom={['x32', 'x32', 'x48']}
      display="flex"
      width="100%"
      minHeight={['492px', '492px', '532px']}
      alignItems="center"
      overflow="hidden"
      justifyContent="center"
    >
      <Grid
        gridTemplateColumns={[
          'repeat(24, 1fr)',
          'repeat(24, 1fr)',
          'repeat(12, 1fr)',
        ]}
        htmlAttrs={{ style: { width: '100%', maxWidth: '1440px' } }}
      >
        <Grid gridColumn={['2 / 24', '2 / 24', '2 / 7']}>
          <Box height={['238px', '238px', '394px']} width={'100%'}>
            <Skeleton
              htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
            />
          </Box>
        </Grid>

        <Grid gridColumn={['2 / 24', '2 / 24', '8 / 11']}>
          <Stack
            layout="vertical"
            htmlAttrs={{
              style: { alignSelf: 'center' },
            }}
          >
            <Box
              height={theme.space.x16}
              width={['200px']}
              marginTop={['x16', 'x16', 'x0']}
            >
              <Skeleton
                htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
              />
            </Box>

            <Stack layout="vertical" margin="x8">
              <Box height={['32px', '32px', '56px']} width={'100%'}>
                <Skeleton
                  htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
                />
              </Box>

              <Box height={['32px', '32px', '56px']} width={'100%'}>
                <Skeleton
                  htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
                />
              </Box>
            </Stack>

            <Box
              height={['16px', '16px', '32px']}
              display="flex"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Box height={theme.space.x16} width={'100px'}>
                <Skeleton
                  htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
                />
              </Box>
              <Box height={theme.space.x16} width={'100px'}>
                <Skeleton
                  htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
                />
              </Box>
            </Box>

            <Box height={theme.space.x56} width={'100%'}>
              <Skeleton
                htmlAttrs={{ style: { borderRadius: theme.borderRadius.x4 } }}
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}
